(function () {
  'use strict';

  angular
    .module('ecapp')
    /**
     * ???
     *
     * @ngdoc directive
     * @name btEventModalNav
     * @memberOf ecapp
     */
    .directive('btEventModalNav', [
      '$templateCache',
      function ($templateCache) {
        return {
          restrict: 'E',
          template: $templateCache.get('directives/event-modal/nav.html'),
        };
      },
    ]);
})();
